// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_logo__nT\\+s6{
    width: 88px;  
    
}
.login_loginBox__beLC1{
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    color:#9396A3;
}
.login_heighFull__bwWS0{
    height: 100vh;
    background-color: #0D0E11;
    position: relative;
    overflow: hidden;
}

.login_heighFull__bwWS0 > *:not(.login_backgroundGlow__wP8CR) {
    position: relative;
    z-index: 1;
}

.login_backgroundGlow__wP8CR {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    overflow: hidden;
}

.login_backgroundSvg__1-eFV {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 100%;
    min-width: 360px;
    min-height: 684px;
}
.login_loginBoxLeftTitle__jQ-Nx{
 color: var(--referral-black);
 color:#F3F4F6;
}
.login_input__PLI4S{
    background-color: transparent;
    width: 100%;
    border: none;
    outline: none;
    color:#9396A3;
}

/* Prevent browser autofill from changing input background color */
.login_input__PLI4S:-webkit-autofill,
.login_input__PLI4S:-webkit-autofill:hover,
.login_input__PLI4S:-webkit-autofill:focus,
.login_input__PLI4S:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
    -webkit-text-fill-color: #9396A3 !important;
    box-shadow: 0 0 0 1000px transparent inset !important;
    background-color: transparent !important;
    color: #9396A3 !important;
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s;
}
.login_loginBoxRight__SxUpF{
    width: 100%;
}
.login_submitButton__wsGhL{
    background-color: var(--referral-black-shade2);
    color: var(--referral-gray-shade3);
    border: none;
    outline: none;
    width: 276px;
    height: 56px;
    border-radius: 40px;
    border-radius: var(--corner-radius-radius-124172-wxh, 16px);
    background: var(--cta-disable-fill, #353945);
    color: var(--cta-disable-text, #6A718B);
}
.login_loginBottomTextLink__gWgyT{
    color: var(referral-blue-background2);
}
.login_blackbox__T1kgF{
    border-bottom: 1px solid var(--referral-gray-shade);
    background: var(--referral-border-color2);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 10px 16px;
    border-radius: var(--corner-radius-tokens-radius-124172-wxh, 12px) var(--corner-radius-tokens-radius-124172-wxh, 12px) 0 0;
border-bottom: 1px solid var(--Neutral-500, #8D93A8);
background: var(--shape-bg-50, #22242B);
color: var(--Text-200, #9396A3);

}
.login_enabledcolor__6oBXW{
    background-color: #fff;
    color:#000;
    /* background-color: var(--theme-primary);
    color: var(--referral-black);
    background: var(--Studio-gradient-CTA-Green-CTA, linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%)); */
}
.login_declarationLabel__m1nsq{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    flex-direction: column;
}
.login_linkText__YZTWp{
    color:#F3F4F6;
}
.login_loginBoxLeftTitleSub__698yf{
    color:#9396A3;
    padding-top: 10px;
}

.login_login_input__Mxbwl{
    color:#9396A3;
}`, "",{"version":3,"sources":["webpack://./src/pages/trial/SignUp/login.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;;AAEf;AACA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;AACA;CACC,4BAA4B;CAC5B,aAAa;AACd;AACA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;AACjB;;AAEA,kEAAkE;AAClE;;;;IAII,6DAA6D;IAC7D,2CAA2C;IAC3C,qDAAqD;IACrD,wCAAwC;IACxC,yBAAyB;IACzB,yDAAiD;IAAjD,iDAAiD;AACrD;AACA;IACI,WAAW;AACf;AACA;IACI,8CAA8C;IAC9C,kCAAkC;IAClC,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,2DAA2D;IAC3D,4CAA4C;IAC5C,uCAAuC;AAC3C;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mDAAmD;IACnD,yCAAyC;IACzC,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,0HAA0H;AAC9H,oDAAoD;AACpD,uCAAuC;AACvC,+BAA+B;;AAE/B;AACA;IACI,sBAAsB;IACtB,UAAU;IACV;;4GAEwG;AAC5G;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,sBAAsB;AAC1B;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".logo{\n    width: 88px;  \n    \n}\n.loginBox{\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: column;\n    color:#9396A3;\n}\n.heighFull{\n    height: 100vh;\n    background-color: #0D0E11;\n    position: relative;\n    overflow: hidden;\n}\n\n.heighFull > *:not(.backgroundGlow) {\n    position: relative;\n    z-index: 1;\n}\n\n.backgroundGlow {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 0;\n    pointer-events: none;\n    overflow: hidden;\n}\n\n.backgroundSvg {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    height: 100%;\n    min-width: 360px;\n    min-height: 684px;\n}\n.loginBoxLeftTitle{\n color: var(--referral-black);\n color:#F3F4F6;\n}\n.input{\n    background-color: transparent;\n    width: 100%;\n    border: none;\n    outline: none;\n    color:#9396A3;\n}\n\n/* Prevent browser autofill from changing input background color */\n.input:-webkit-autofill,\n.input:-webkit-autofill:hover,\n.input:-webkit-autofill:focus,\n.input:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 1000px transparent inset !important;\n    -webkit-text-fill-color: #9396A3 !important;\n    box-shadow: 0 0 0 1000px transparent inset !important;\n    background-color: transparent !important;\n    color: #9396A3 !important;\n    transition: background-color 5000s ease-in-out 0s;\n}\n.loginBoxRight{\n    width: 100%;\n}\n.submitButton{\n    background-color: var(--referral-black-shade2);\n    color: var(--referral-gray-shade3);\n    border: none;\n    outline: none;\n    width: 276px;\n    height: 56px;\n    border-radius: 40px;\n    border-radius: var(--corner-radius-radius-124172-wxh, 16px);\n    background: var(--cta-disable-fill, #353945);\n    color: var(--cta-disable-text, #6A718B);\n}\n.loginBottomTextLink{\n    color: var(referral-blue-background2);\n}\n.blackbox{\n    border-bottom: 1px solid var(--referral-gray-shade);\n    background: var(--referral-border-color2);\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    padding: 10px 16px;\n    border-radius: var(--corner-radius-tokens-radius-124172-wxh, 12px) var(--corner-radius-tokens-radius-124172-wxh, 12px) 0 0;\nborder-bottom: 1px solid var(--Neutral-500, #8D93A8);\nbackground: var(--shape-bg-50, #22242B);\ncolor: var(--Text-200, #9396A3);\n\n}\n.enabledcolor{\n    background-color: #fff;\n    color:#000;\n    /* background-color: var(--theme-primary);\n    color: var(--referral-black);\n    background: var(--Studio-gradient-CTA-Green-CTA, linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%)); */\n}\n.declarationLabel{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 4px;\n    flex-direction: column;\n}\n.linkText{\n    color:#F3F4F6;\n}\n.loginBoxLeftTitleSub{\n    color:#9396A3;\n    padding-top: 10px;\n}\n\n.login_input{\n    color:#9396A3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `login_logo__nT+s6`,
	"loginBox": `login_loginBox__beLC1`,
	"heighFull": `login_heighFull__bwWS0`,
	"backgroundGlow": `login_backgroundGlow__wP8CR`,
	"backgroundSvg": `login_backgroundSvg__1-eFV`,
	"loginBoxLeftTitle": `login_loginBoxLeftTitle__jQ-Nx`,
	"input": `login_input__PLI4S`,
	"loginBoxRight": `login_loginBoxRight__SxUpF`,
	"submitButton": `login_submitButton__wsGhL`,
	"loginBottomTextLink": `login_loginBottomTextLink__gWgyT`,
	"blackbox": `login_blackbox__T1kgF`,
	"enabledcolor": `login_enabledcolor__6oBXW`,
	"declarationLabel": `login_declarationLabel__m1nsq`,
	"linkText": `login_linkText__YZTWp`,
	"loginBoxLeftTitleSub": `login_loginBoxLeftTitleSub__698yf`,
	"login_input": `login_login_input__Mxbwl`
};
export default ___CSS_LOADER_EXPORT___;
